export default __webpack_public_path__ + "static/media/logo-ed-print.507fe3c9.svg";